import { SortOrder } from "sprint-common-web";

import { ContentVersionSource } from "../../../common/types/ContentVersionSource";
import { MovieVersionListingItem } from "./MovieVersionListingItem";

export interface MovieVersionListingFilters {
    page: number;
    pageSize: number;
    sortBy: keyof MovieVersionListingItem;
    sortOrder: SortOrder;
    sources?: ContentVersionSource[];
    includeMerged: boolean;
}

export const movieVersionOrigins = [
    ContentVersionSource.Sprint,
    ContentVersionSource.Buzz,
    ContentVersionSource.Shreq,
    ContentVersionSource.Trailer
];

export const defaultMovieVersionListingFilters: MovieVersionListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "distributorName",
    sortOrder: "asc",
    sources: movieVersionOrigins,
    includeMerged: false
};
